import { render, staticRenderFns } from "./CourierSelectedDialog.vue?vue&type=template&id=97255780&scoped=true&"
import script from "./CourierSelectedDialog.vue?vue&type=script&lang=js&"
export * from "./CourierSelectedDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97255780",
  null
  
)

export default component.exports